export const plugins = {
    enabled: true,
    dataCarrier: {
        availableStatementPeriodicities: [] as string[],
        availableStatementFormats: [] as string[],
        isSignableBasedOnSignInfo: true,
        isNewNameInputVisible: true,
        isUploadSubTypeEnabled: false,
        contentTypeHeader: 'application/json',
        displayBulkDownloadFormatSelect: true,
        maxBundleSigningSize: 1,
    },
};
